import { Navigate, useLocation } from 'react-router-dom';
import ApiService from './ApiService';

const RouteGuard = ({ element: Component, allowedRoles }) => {
  const location = useLocation();

  let hasRequireRole = false;

  if (!allowedRoles || allowedRoles.length === 0) {
    hasRequireRole = true;
  } else {
    hasRequireRole = allowedRoles.some((role) => {
      if (role === 'ADMIN') {
        return ApiService.isAdmin();
      } else if (role === 'CUSTOMER') {
        return ApiService.isCustomer();
      } else if (role === 'PILOT') {
        return ApiService.isPilot();
      }

      return false;
    });
  }

  if (hasRequireRole) {
    return Component;
  } else {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
};

export default RouteGuard;
